<template>
    <v-container>
        <v-layout>
            <v-flex>
                <div>
                    <v-tooltip top>
                        <v-btn
                                class="mr-2 mb-2"
                                @click="newCovidTracer"
                                color="customPurple"
                                dark
                                fixed
                                bottom
                                right
                                fab
                                slot="activator"
                        >
                            <v-icon>add</v-icon>
                        </v-btn>
                        <span>Crear Seguimiento</span>
                    </v-tooltip>
                    <v-layout>
                        <v-flex xs12 sm6 offset-sm6>
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-dialog
                    v-model="dialog"
                    fullscreen hide-overlay transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Crear Seguimiento</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm7 offset-sm1>
                                    <table align="center" width="100%" bgcolor="#E0E0E0">
                                        <tbody>
                                        <tr>
                                            <td>
                                                <b>Paciente:</b>
                                                {{this.$store.state.covid.name}}
                                            </td>
                                            <td>
                                                <b>Identificación:</b>
                                                {{this.$store.state.covid.identification}}
                                            </td>
                                            <td>
                                                <b>Teléfono:</b>
                                            </td>
                                            <td>{{this.$store.state.covid.phone}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm7 offset-sm1>
                                    <v-textarea
                                            name="pregunta"
                                            label="Ingrese la pregunta"
                                            id="nombre"
                                            v-model="surveyData.pregunta"
                                            v-on:keyup.enter="saveData"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-select
                                            :items="tipoPreguntaItems"
                                            v-model="surveyData.tipoPregunta"
                                            label="Tipo de pregunta"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                            <v-layout v-if="surveyData.tipoPregunta=='Opciones'">
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="ingrese una opcion"
                                            label="Ingrese una opción"
                                            id="value"
                                            v-model="inputOpcion"
                                    ></v-text-field>
                                    <v-btn @click="agregarPreguntaData" small color="primary">Agregar Opción</v-btn>
                                    <div v-for="item in surveyData.tipoPreguntaData">
                                        <span>{{item}}</span>
                                        <v-tooltip top>
                                            <v-btn fab dark small @click="deleteItemOption(item)" slot="activator"
                                                   color="primary">
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm6 offset-sm4>
                                    <div>
                                        <v-btn
                                                @click="agregarPregunta" large color="primary">Agregar Pregunta
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                        <v-data-table
                                :headers="headersPreguntas"
                                :items="this.surveyDataList"
                                class="elevation-1"
                                sort-icon="mdi-menu-down"
                                :search="search"
                        >
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left">{{ props.item.contNumber }}</td>
                                <td class="text-xs-left">{{ props.item.pregunta }}</td>
                                <td class="text-xs-left">{{ props.item.tipoPregunta }}</td>
                                <td class="text-xs-left">{{ props.item.tipoPreguntaData }}</td>
                                <td>
                                    <v-tooltip top>
                                        <v-btn fab dark small @click="deleteItemPregunta(props.item)" slot="activator"
                                               color="primary">
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                                </td>
                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                No se han encontrado resultados para "{{ search }}".
                            </v-alert>
                        </v-data-table>
                        <div class="text-xs-center" :disabled="!valid">
                            <v-btn color="primary" @click="saveData" dark>Enviar seguimiento</v-btn>
                        </div>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-layout>
        <h3 class="primary--text">Lista de Seguimientos</h3>
        <v-data-table
                :headers="headers"
                :items="this.covidTracerList"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="search"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.covid.lastName }} {{ props.item.covid.name }}</td>
                <td class="text-xs-left">{{ props.item.covid.identification }}</td>
                <td class="text-xs-left">{{ props.item.date }}</td>
                <td>
                    <a @click="getSeguimiento(props.item)">Ver seguimiento</a>
                </td>
                <td>
                    <a @click="getSeguimientoMap(props.item)">Ver mapa</a>
                </td>
                <td>
                    <v-tooltip top>
                        <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                    </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
        <br>
        <br>
        <v-layout>
            <v-flex xs12 sm6 offset-sm4>
                <div>
                    <router-link :to="{name: 'covid'}" exact>Regresar a registros</router-link>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>

    import CovidTracer from "../../model/CovidTracer";

    export default {
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                contNumber: 0,
                headers: [
                    {text: 'Paciente', value: 'covidPatient.lastName'},
                    {text: 'Identificación', value: 'covidPatient.idnetification'},
                    {text: 'Fecha Seguimiento', value: 'date'},
                    {text: 'Seguimiento', value: 'seguimiento'},
                    {text: 'Ver Mapa', value: 'mapa'},
                    {text: 'Acciones', value: 'acciones'},


                ],
                headersPreguntas: [
                    {text: 'Numero Pregunta', value: 'contNumber'},
                    {text: 'Pregunta', value: 'pregunta'},
                    {text: 'Tipo Pregunta', value: 'tipoPregunta'},
                    {text: 'Opciones', value: 'tipoPreguntaData'},
                    {text: 'Eliminar', value: 'eliminar'},

                ],
                tipoPreguntaItems: ["Pregunta Abierta", "Opciones", "Solo Texto"],
                opciones: [],
                editedIndex: -1,
                surveyData: {pregunta: "", tipoPregunta: "", tipoPreguntaData: [], contNumber: 0},
                inputOpcion: "",
                surveyDataList: [],
                covidTracer: new CovidTracer(),
                covidTracerList: []
            };
        }, methods: {
            agregarPreguntaData() {
                this.surveyData.tipoPreguntaData.push(this.inputOpcion)
                this.inputOpcion = ""
            },
            agregarPregunta() {
                this.contNumber = this.contNumber + 1
                this.surveyData.contNumber=this.contNumber
                this.surveyDataList.push(this.surveyData)
                this.surveyData = {pregunta: "", tipoPregunta: "", tipoPreguntaData: []}
            },
            cleanData() {
                this.$refs.form.reset()
                this.covidTracer = new CovidTracer()
                this.valid = false
                this.dialog = false
            },
            newCovidTracer() {
                this.editedIndex = -1
                this.valid = false
                this.dialog = true
                this.$refs.form.reset()
                this.covidTracer = new CovidTracer()
                this.surveyData = {pregunta: "", tipoPregunta: "", tipoPreguntaData: [], respuesta: ""},
                    this.inputOpcion = "",
                    this.surveyDataList = []
            },
            saveData() {
                var r = confirm('¿Está seguro de que enviar el seguimiento con las preguntas ingresadas? Se enviará un correo electrónico al paciente.')
                if (r) {
                    if (this.editedIndex > -1) {
                        this.covidTracer.value = JSON.stringify(this.surveyDataList)
                        this.covidTracer.date = new Date()
                        this.covidTracer.covid = this.$store.state.covid
                        this.covidTracer.covid.date = new Date()
                        this.$store.dispatch('updateCovidTrace', this.covidTracer).then(response => {
                            this.cleanData()
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    } else {
                        this.covidTracer.value = JSON.stringify(this.surveyDataList)
                        this.covidTracer.date = new Date()
                        this.covidTracer.covid = this.$store.state.covid
                        this.covidTracer.covid.date = new Date()
                        this.$store.dispatch('addCovidTrace', this.covidTracer).then(response => {
                            this.cleanData()
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                    this.dialog = false
                }

            },
            editItem(item) {
                this.editedIndex = this.covidTracerList.indexOf(item)
                this.covidTracer = Object.assign({}, item)
                this.dialog = true
            },
            deleteItem(item) {
                this.editedIndex = this.covidTracerList.indexOf(item)
                this.covidTracer = Object.assign({}, item)
                confirm('Está seguro de que quiere eliminar el resgitro?') && this.$store.dispatch('deleteCovidTrace', this.covidTracer.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            deleteItemOption(item) {
                const index = this.surveyData.tipoPreguntaData.indexOf(item)
                confirm('Está seguro de que quiere eliminar el registro?') && this.surveyData.tipoPreguntaData.splice(index, 1)

            },
            deleteItemPregunta(item) {
                const index = this.surveyDataList.indexOf(item)
                confirm('Está seguro de que quiere eliminar el registro?') && this.surveyDataList.splice(index, 1)
                this.contNumber = this.contNumber - 1

            },
            reloadData() {
                this.$store.dispatch('getCovidTraceListByCovidId', this.$store.state.covid.id).then(
                    response => {
                        this.covidTracerList = this.$store.state.covidTraceList
                        for (let i=0;i<this.covidTracerList.length;i++) {
                            this.covidTracerList[i].date=this.getFormattedDate(this.covidTracerList[i].date)
                        }
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
            },
            getSeguimiento(item) {
                this.editedIndex = this.covidTracerList.indexOf(item);
                this.$store.state.seguimiento = Object.assign({}, item)
                this.$router.push({name: 'covidTracerResponse'});

            },
            getSeguimientoMap(item) {
                this.editedIndex = this.covidTracerList.indexOf(item);
                this.$store.state.seguimiento = Object.assign({}, item)
                this.$router.push({name: 'covidTracerMap'});

            },
            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                    // Para Safari
                    if (!(dateReg instanceof Date)) {
                        var b = dateReg.toString().split(/\D/);
                        date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                    } else {
                        date = new Date(dateReg);
                    }
                }  else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },
        },
        computed: {},
        created() {
            this.reloadData()            
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/covid/CovidTracer.vue